import { render, staticRenderFns } from "./OrderCancellationRequest.vue?vue&type=template&id=3e185476"
import script from "./OrderCancellationRequest.vue?vue&type=script&lang=js"
export * from "./OrderCancellationRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports